// VHS attaches subtitle tracks async and re-shows the DEFAULT=YES one, so each track's mode is
// forced back to 'disabled' on every modechange, not just once at setup.
const disableSubtitleTracks = (player) => {
  const keepDisabled = (track) => {
    track.mode = 'disabled';
    track.on('modechange', () => {
      track.mode = 'disabled';
    });
  };

  const tracks = player.textTracks();
  for (let i = 0; i < tracks.length; i++) keepDisabled(tracks[i]);
  tracks.on('addtrack', (e) => keepDisabled(e.track));
};

export default disableSubtitleTracks;
